import React, { useEffect } from 'react';
import { Field } from 'formik';
import Immutable from 'immutable';
import c from 'classnames';
import { useLocation } from 'react-router-dom';

const tokenReplacer = (token) => {
  const urlSearchParams = new URLSearchParams(window ? window.location.search : '');
  const params = Object.fromEntries(urlSearchParams.entries());

  const values = Immutable.fromJS({
    headless: {
      'current-page': window ? window.location.href : null,
      referrer: document ? document.referrer : null,
      query: params,
    },
  });

  const array = [...token.matchAll(/\[.+?\]/g)];
  array.forEach(([item]) => {
    const elements = item.substring(1, item.length - 1).split(':');
    token = token.replace(item, values.getIn(elements, item));
  });

  return token;
};

const WebformHidden = ({ entity, customClasses, setFieldValue, ...fieldProps }) => {
  const location = useLocation();

  const key = entity.get('#webform_key');
  const wrapperClassNames = c('WebformHidden', entity.getIn(['#wrapper_attributes', 'class', 0], ''));
  const defaultValue = entity.get('#default_value', null);

  useEffect(() => {
    if (defaultValue) {
      setFieldValue(key, tokenReplacer(defaultValue));
    }
  }, [setFieldValue, key, defaultValue, location]);

  return (
    <div className={wrapperClassNames}>
      <Field
        className="hidden"
        name={key}
        type="text"
        value={fieldProps.values[key]}
      />
    </div>
  );
};

export default WebformHidden;
